import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getMapPreviewSrc } from '../utils/element';
const StaticMapPreview = ({ alt, className = 'map-static-preview', decorative = false, }) => {
    const previewSrc = getMapPreviewSrc();
    if (!previewSrc) {
        return null;
    }
    return (_jsx("div", { className: className, "aria-hidden": decorative, children: _jsx("img", { src: previewSrc, alt: decorative ? '' : alt, width: 1280, height: 720, loading: "eager", fetchPriority: "high", decoding: "async" }) }));
};
export default StaticMapPreview;
